import i18n from "@/utils/i18n";

/**
 * Backend'den gelen ham rol adlarını (system role name) i18n namespace'i
 * altında saklı kullanıcı dostu label'lara çevirir.
 *
 * Bu map, hem `StaffManagementPage` tablosundaki ROL sütununda,
 * hem de `RolesAndPermissionsPage` rol listesinde kullanılır.
 *
 * Eşleşme bulunamazsa ham değer fallback olarak döner.
 */
const ROLE_KEY_MAP: Record<string, string> = {
  "egitim-yonetici": "educationManager",
  "egitim-sorumlusu": "educationOfficer",
  egitmen: "educator",
  "daire-baskani": "departmentHead",
  "central-manager": "centralManager",
  "isletme-muduru": "businessManager",
  "staj-yonetici": "internshipManager",
  kursiyer: "trainee",
  intern: "intern",
  user: "user",
};

/**
 * Ham rol adını display name'e çevirir.
 * Bilinmeyen rol adları olduğu gibi geri döner (güvenli fallback).
 */
export const getRoleDisplayName = (rawName: string | null | undefined): string => {
  if (!rawName) return "";
  const key = rawName.trim();
  if (!key) return "";
  const i18nKey = ROLE_KEY_MAP[key];
  if (!i18nKey) return key;
  const fullKey = `roleDisplayNames.${i18nKey}`;
  const translated = i18n.t(fullKey);
  return translated === fullKey ? key : translated;
};
